module.exports = __webpack_public_path__ + "images/logo/hikakaku_logo_fe9f89b0b46dc5b7686230dc61858c33.webp";